import React from 'react';
import { Box, Button, Stack, Text, TextInput, ThemeIcon, Title } from '@mantine/core';
import { IconLifebuoy } from '@tabler/icons-react';
import FlowAlert from '@/components/auth/flow/components/parts/Flow.Alert';
import FlowAlternatives from '@/components/auth/flow/components/parts/Flow.Alternatives';
import recoveryCodeSanitize, { RECOVERY_CODE_PATTERN } from '@/function/auth/recovery.code.sanitize';
import type { TypeFlowScreenProps } from '@/types/auth/types.auth.flow';

type Props = TypeFlowScreenProps & { step: string; passkeySupported: boolean };

const FlowRecoveryCode: React.FC<Props> = ({ flow, message, step, passkeySupported }) => {
    const [code, setCode] = React.useState('');
    const [local, setLocal] = React.useState<string | null>(null);
    const fieldError = local ?? (message?.field === 'code' ? message.text : null);

    const submit = (event: React.FormEvent) => {
        event.preventDefault();
        if (flow.busy) return;
        if (!RECOVERY_CODE_PATTERN.test(code)) {
            setLocal('Il codice di recupero ha la forma ABCD-1234');
            return;
        }
        void flow.submit(step, { code });
    };

    return (
        <form onSubmit={submit} noValidate>
            <Stack align="center" gap="lg">
                <ThemeIcon size={64} radius="xl" variant="light" color="orange">
                    <IconLifebuoy size={34} />
                </ThemeIcon>
                <Box style={{ textAlign: 'center', maxWidth: 380 }}>
                    <Title order={3}>Codice di recupero</Title>
                    <Text c="dimmed" size="sm" mt={6}>Usa uno dei codici di recupero che hai salvato quando hai attivato la verifica in due passaggi. Ognuno vale una volta sola.</Text>
                </Box>
                <Box w="100%"><FlowAlert message={message} field="code" /></Box>
                <TextInput
                    w="100%"
                    maw={320}
                    label="Codice di recupero"
                    placeholder="ABCD-1234"
                    autoComplete="one-time-code"
                    autoCapitalize="characters"
                    spellCheck={false}
                    maxLength={9}
                    ff="monospace"
                    data-autofocus
                    value={code}
                    error={fieldError ?? undefined}
                    onChange={(event) => { setLocal(null); setCode(recoveryCodeSanitize(event.currentTarget.value)); }}
                />
                <Button type="submit" fullWidth maw={320} radius="md" loading={flow.busy} disabled={flow.busy}>CONFERMA</Button>
                <FlowAlternatives flow={flow} current="recovery-code" passkeySupported={passkeySupported} />
            </Stack>
        </form>
    );
};

export default FlowRecoveryCode;
